import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import loadi18n from './locale/i18n';
import { setLanguage } from '@cmsgov/ds-healthcare-gov';
import App from './components/App';
import * as serviceWorker from './serviceWorker';

import './styles/index.scss';

const locale = window.location.hostname.includes('cuidadodesalud.gov') ? 'es' : 'en';
// set lang on <html>
document.documentElement.lang = locale;
setLanguage(locale);
const i18n = loadi18n(locale);

document.title = i18n.t('estimatorPageTitle');

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n} initialLanguage={locale}>
      <App locale={locale} />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
